import { Resolver, Subscription, Root, Arg } from 'type-graphql'
import { filter, pipe } from 'graphql-yoga'
import { pubsub } from '@things-factory/shell'
import { Board } from './board.js'

@Resolver(Board)
export class BoardSubscription {
  @Subscription({
    description: 'Subscribes to real-time updates for a specific board.',
    subscribe: ({ args, context, info }) => {
      const { domain, user } = context.state
      const { id } = args
      const subdomain = domain?.subdomain

      if (!domain) {
        throw new Error('domain required')
      }

      if (!user.domains?.find(d => d.subdomain === subdomain) && !process.superUserGranted(domain, user)) {
        throw new Error(`domain(${subdomain}) is not working for user(${user.email}).`)
      }

      return pipe(
        pubsub.subscribe('board'),
        filter((payload: { board: Board }) => {
          const { domainId, id: boardId } = payload.board

          if (domainId !== domain.id) {
            return false
          }

          if (id !== boardId) {
            return false
          }

          return true
        })
      )
    }
  })
  board(@Root() payload: { board: Board }, @Arg('id') id: string): Board {
    return payload.board
  }
}
